/**
 * networkFailureOwner — un écran dit-il lui-même ses échecs réseau ?
 *
 * Deux surfaces legacy parlent pour toute l'app quand le réseau manque : la boîte « Pas de connexion
 * Internet » d'`apiRequest` et de `vaporFileUpload`, et celle de l'intercepteur axios d'`App.js`
 * (« Problème de connexion réseau »). Un écran du design system qui tient ses échecs (le live,
 * l'exécution d'une activité et la messagerie de l'élève : la reconnexion, la file d'envoi,
 * « Réessayer », « Non envoyé » et « Renvoyer » ; l'écran de l'espace tuteur qui a le focus, hors live :
 * `useOwnNetworkFailuresWhileFocused`) les montre à sa place ; tant qu'il est là, les deux boîtes se
 * taisent, pour toutes les requêtes — celles des pièces legacy encore montées comprises. Seules des
 * pièces du design system le déclarent : sans elles (les espaces élève et tuteur éteints), ce registre
 * reste à zéro et rien ne change.
 */
import { createPresenceCount } from "./presenceCount"

const owners = createPresenceCount()

/** Un écran tient ses échecs réseau : rend la fonction qui le relâche (une seule fois). */
export const ownNetworkFailures = owners.hold

/** Vrai quand un écran dit lui-même ses échecs réseau : les boîtes legacy se taisent. */
export const networkFailuresOwned = owners.held
